import { render, staticRenderFns } from "./CharactersPage.vue?vue&type=template&id=5380806c&scoped=true"
import script from "./CharactersPage.vue?vue&type=script&lang=ts"
export * from "./CharactersPage.vue?vue&type=script&lang=ts"
import style0 from "./CharactersPage.vue?vue&type=style&index=0&id=5380806c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5380806c",
  null
  
)

export default component.exports